// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-trigger-list' )
export class AutomatorBuilderItemTriggerList extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: String } ) accessor logic = '';

	@property( { type: Array, attribute: false } ) accessor items = [];

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="items">
				${ repeat(
					this.items,
					item => item.id,
					item => html`
						<uap-builder-item-trigger
							parent-id=${ item.miscellaneous?.parent_id || UncannyAutomator._recipe.recipe_id }
							item-id=${ item.id }
							item-code=${ item.code }
							integration-code=${ item.integration_code }

							?is-item-on=${ item.is_item_on }
							?uses-credit=${ item.miscellaneous.uses_credit }

							.fields=${ item.fields }
							.tokens=${ item.tokens }
							.backup=${ item.backup }
						></uap-builder-item-trigger>
					`
				) }
			</div>
		`;
	}
}
